import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetContestActivityLogBySweepstakeId = (contestId: number) => {
  const get = useTypedApiClient({
    path: '/admin/contests-activity-log/contests/{contestId}',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/contests-activity-log', contestId],
    queryFn: async () => {
      const { data } = await get({ contestId })
      return data
    },
  })
}
